//hiddenInput
/* Simple plugin that reveals a form field with a link. It just removes a class of .hide */
(function ($) {
    $.fn.hiddenInput = function (args) {
        var options = {
            selector: null, //optional class name of form field to reveal
            callback: function () { }
        };

        $.extend(options, args);

        return this.each(function () {
            if (!options.selector) {
                options.selector = '.hide';
            }

            $(this).on('click', function (e) {
                e.preventDefault();
                $(this).hide().siblings(options.selector).removeClass('hide').filter('input').focus();
                options.callback.call(this);
            });
        });
    };
})(jQuery);